/*
 *
 *   reducer
 *
 */
import produce from "immer"
// import key from "./key"

import {
  LOAD_RECORDS_VALID_CACHE,
  LOAD_RECORDS_META_DATA_SUCCESS,
  LOAD_RECORDS_META_DATA_ERROR,
  LOAD_DELIVERABLES_RECORDS_META_DATA_SUCCESS,
  LOAD_DELIVERABLES_RECORDS_META_DATA_ERROR,
  LOAD_RECORD_QUOTATION_DETAILS,
  LOAD_RECORD_QUOTATION_DETAILS_ERROR,
  LOAD_RECORD_QUOTATION_DETAILS_SUCCESS,
  CREATE_QUOTATION_RECORD_SUCCESS,
  UPDATE_QUOTATION_RECORD_SUCCESS,
  DELETE_QUOTATION_RECORD_SUCCESS,
  CREATE_QUOTATION_RECORD_ERROR,
  UPDATE_QUOTATION_RECORD_ERROR,
  DELETE_QUOTATION_RECORD_ERROR,
  LOAD_DELIVERABLE_DETAILS_ERROR,
  LOAD_DELIVERABLE_DETAILS_SUCCESS,
  CREATE_DELIVERABLE_SUCCESS,
  CREATE_DELIVERABLE_ERROR,
  UPDATE_DELIVERABLE_SUCCESS,
  UPDATE_DELIVERABLE_ERROR,
  UPDATE_EXPIRY_DATE_SUCCESS,
  UPDATE_EXPIRY_DATE_ERROR,
  DELETE_DELIVERABLE_SUCCESS,
  DELETE_DELIVERABLE_ERROR,
  CREATE_VALUE_INSERT_SUCCESS,
  CREATE_VALUE_INSERT_ERROR,
  LOAD_VALUE_INSERT_SUCCESS,
  UPDATE_VALUE_INSERT_SUCCESS,
  DELETE_VALUE_INSERT_SUCCESS,
  UPDATE_VALUE_INSERT_ERROR,
  DELETE_VALUE_INSERT_ERROR,
  LOAD_VALUE_INSERT_ERROR,
  CREATE_INSTRUCTIONS_SUCCESS,
  CREATE_INSTRUCTIONS_ERROR,
  LOAD_INSTRUCTIONS_SUCCESS,
  UPDATE_INSTRUCTIONS_SUCCESS,
  DELETE_INSTRUCTIONS_SUCCESS,
  UPDATE_INSTRUCTIONS_ERROR,
  DELETE_INSTRUCTIONS_ERROR,
  LOAD_INSTRUCTIONS_ERROR,

  //Photography
  CREATE_PHOTOGRAPHY_SUCCESS,
  CREATE_PHOTOGRAPHY_ERROR,
  UPDATE_PHOTOGRAPHY_SUCCESS,
  UPDATE_PHOTOGRAPHY_ERROR,
  DELETE_PHOTOGRAPHY_SUCCESS,
  DELETE_PHOTOGRAPHY_ERROR,
  LOAD_PHOTOGRAPHY_SUCCESS,
  LOAD_PHOTOGRAPHY_ERROR,
  LOAD_SERVICE_DETAILS_SUCCESS,
  LOAD_SERVICE_DETAILS_ERROR,
  LOAD_SERVICE_ACCOUNT_SUCCESS,
  LOAD_SERVICE_ACCOUNT_ERROR,
  APPROVE_QC_REQUEST_SUCCESS,
  APPROVE_QC_REQUEST_ERROR,
  LOAD_QUOTATION_HISTORY_DETAILS_SUCCESS,
  LOAD_QUOTATION_HISTORY_DETAILS_ERROR,
  LOAD_SALES_APPROVAL_SUCCESS,
  LOAD_SALES_APPROVAL_ERROR,
  LOAD_EMPLOYEE_SUCCESS,
  LOAD_EMPLOYEE_ERROR,
  LOAD_QC_HISTORY_SUCCESS,
  LOAD_QC_HISTORY_ERROR,
  UPDATE_QC_REAPPROVE_SUCCESS,
  UPDATE_QC_REAPPROVE_ERROR,
  LOAD_QC_LAYOUT_MASTER_SUCCESS,
  LOAD_QC_LAYOUT_MASTER_ERROR,
  UPDATE_QUOTATION_LIST_SUCCESS,
  UPDATE_QUOTATION_LIST_ERROR,
  LOAD_QUOTATION_LIST_SUCCESS,
  LOAD_QUOTATION_LIST_ERROR,
  LOAD_QC_LAYOUT_SEGMENT_SUCCESS,
  LOAD_QC_LAYOUT_SEGMENT_ERROR,

  //Qc preview
  LOAD_QUOTATION_PREVIEW_SUCCESS,
  LOAD_QUOTATION_PREVIEW_ERROR,
  UPDATE_QUOTATION_PREVIEW_SUCCESS,
  UPDATE_QUOTATION_PREVIEW_ERROR,
  ADD_SEGMENT_PREVIEW_SUCCESS,
  ADD_SEGMENT_PREVIEW_ERROR,
  LOAD_EC_DELIVERABLE_DETAILS_SUCCESS,
  LOAD_EC_DELIVERABLE_DETAILS_ERROR,

  //EC DELIVERABLES
  LOAD_DELIVERABLE_EMPLOYEE_SUCCESS,
  LOAD_DELIVERABLE_EMPLOYEE_ERROR,
  UPDATE_DISCOUNT_PREVIEW_SUCCESS,
  UPDATE_DISCOUNT_PREVIEW_ERROR,
  LOAD_PROCESS_STATUS_SUCCESS,
  LOAD_PROCESS_STATUS_ERROR,
  LOAD_INSTRUCTIONS_RECORDS_META_DATA_ERROR,
  LOAD_INSTRUCTIONS_RECORDS_META_DATA_SUCCESS,
} from "./constants"

const initialState = {
  record: [],
  record_quotation_details: [],
  deliverable_details: [],
  ec_deliverable_details: [],
  quotation_preview: [],
  service_total_account: [],
  instructions: [],
  checklist_details: [],
  service_details: [],
  value_insert: [],
  quotation_history: [],
  quotationList: [],
  sales_details: [],
  employee_list: [],
  qc_history: [],
  quotationRecordsMetaData: {},
  deliverablesMetaData: {},
  instructionsMetaData: {},
  loading: false,
  error: false,
  success: false,
  qc_layout_master: [],
  qc_layout_segment: [],
  deliver_employeelist: [],
  processStatus: [],
}

export default function Reducer(
  state = initialState,
  {
    id,
    record_quotation_details,
    quotationRecordsMetaData,
    deliverablesMetaData,
    instructionsMetaData,
    deliverable_details,
    ec_deliverable_details,
    instructions,
    value_insert,
    checklist_details,
    service_total_account,
    service_details,
    quotation_history,
    quotation_preview,
    sales_details,
    employee_list,
    quotationList,
    qc_history,
    record,
    type,
    error,
    success,
    qc_layout_master,
    qc_layout_segment,
    deliver_employeelist,
    processStatus,
  }
) {
  return produce(state, (draft) => {
    switch (type) {
      case LOAD_RECORDS_VALID_CACHE:
        draft.loading = false
        draft.error = false
        draft.success = false
        break
      case LOAD_RECORD_QUOTATION_DETAILS:
        draft.loading = true
        draft.error = false
        draft.success = false
        break
      case LOAD_RECORD_QUOTATION_DETAILS_SUCCESS:
        console.log(
          record_quotation_details,
          "-------------------quotation details"
        )
        draft.record_quotation_details = record_quotation_details
        draft.lastUpdate = Math.floor(Date.now() / 1000)
        draft.loading = false
        draft.error = false
        draft.success = false
        break
      case LOAD_DELIVERABLE_DETAILS_SUCCESS:
        draft.deliverable_details = deliverable_details
        draft.lastUpdate = Math.floor(Date.now() / 1000)
        draft.loading = false
        draft.error = false
        draft.success = false
        break
      case LOAD_EC_DELIVERABLE_DETAILS_SUCCESS:
        draft.ec_deliverable_details = ec_deliverable_details
        draft.lastUpdate = Math.floor(Date.now() / 1000)
        draft.loading = false
        draft.error = false
        draft.success = false
        break
      case LOAD_SERVICE_ACCOUNT_SUCCESS:
        draft.service_total_account = service_total_account
        draft.lastUpdate = Math.floor(Date.now() / 1000)
        draft.loading = false
        draft.error = false
        draft.success = false
        break
      case LOAD_INSTRUCTIONS_SUCCESS:
        draft.instructions = instructions
        draft.lastUpdate = Math.floor(Date.now() / 1000)
        draft.loading = false
        draft.error = false
        draft.success = false
        break
      case LOAD_PROCESS_STATUS_SUCCESS:
        draft.processStatus = processStatus
        draft.lastUpdate = Math.floor(Date.now() / 1000)
        draft.loading = false
        draft.error = false
        draft.success = false
        break
      case LOAD_VALUE_INSERT_SUCCESS:
        draft.value_insert = value_insert
        draft.lastUpdate = Math.floor(Date.now() / 1000)
        draft.loading = false
        draft.error = false
        draft.success = false
        break
      case LOAD_PHOTOGRAPHY_SUCCESS:
        draft.checklist_details = checklist_details
        draft.lastUpdate = Math.floor(Date.now() / 1000)
        draft.loading = false
        draft.error = false
        draft.success = false
        break
      case LOAD_SERVICE_DETAILS_SUCCESS:
        draft.service_details = service_details
        draft.lastUpdate = Math.floor(Date.now() / 1000)
        draft.loading = false
        draft.error = false
        draft.success = false
        break
      case LOAD_SALES_APPROVAL_SUCCESS:
        draft.sales_details = sales_details
        draft.lastUpdate = Math.floor(Date.now() / 1000)
        draft.loading = false
        draft.error = false
        draft.success = false
        break
      case LOAD_DELIVERABLE_EMPLOYEE_SUCCESS:
        draft.deliver_employeelist = deliver_employeelist
        draft.lastUpdate = Math.floor(Date.now() / 1000)
        draft.loading = false
        draft.error = false
        draft.success = false
        break
      case LOAD_EMPLOYEE_SUCCESS:
        draft.employee_list = employee_list
        draft.lastUpdate = Math.floor(Date.now() / 1000)
        draft.loading = false
        draft.error = false
        draft.success = false
        break
      case LOAD_QUOTATION_HISTORY_DETAILS_SUCCESS:
        draft.quotation_history = quotation_history
        draft.loading = false
        draft.error = error
        draft.success = success
        break
      case LOAD_QC_HISTORY_SUCCESS:
        draft.qc_history = qc_history
        draft.lastUpdate = Math.floor(Date.now() / 1000)
        draft.loading = false
        draft.error = false
        draft.success = false
        break
      case LOAD_QUOTATION_LIST_SUCCESS:
        draft.quotationList = quotationList
        draft.lastUpdate = Math.floor(Date.now() / 1000)
        draft.loading = false
        draft.error = false
        draft.success = false
        break
      case LOAD_QUOTATION_PREVIEW_SUCCESS:
        draft.quotation_preview = quotation_preview
        draft.lastUpdate = Math.floor(Date.now() / 1000)
        draft.loading = false
        draft.error = false
        draft.success = false
        break

      case LOAD_RECORDS_META_DATA_SUCCESS:
        draft.quotationRecordsMetaData = quotationRecordsMetaData
        draft.loading = false
        draft.error = error
        draft.success = success
        break
      case LOAD_DELIVERABLES_RECORDS_META_DATA_SUCCESS:
        draft.deliverablesMetaData = deliverablesMetaData
        draft.loading = false
        draft.error = error
        draft.success = success
        break
      case LOAD_INSTRUCTIONS_RECORDS_META_DATA_SUCCESS:
        draft.instructionsMetaData = instructionsMetaData
        draft.loading = false
        draft.error = error
        draft.success = success
        break

      case CREATE_QUOTATION_RECORD_SUCCESS:
      case ADD_SEGMENT_PREVIEW_SUCCESS:
      case CREATE_INSTRUCTIONS_SUCCESS:
      case CREATE_DELIVERABLE_SUCCESS:
      case CREATE_PHOTOGRAPHY_SUCCESS:
      case CREATE_VALUE_INSERT_SUCCESS:
        draft.record = [record].concat(state.record)
        draft.loading = false
        draft.error = false
        draft.success = success
        break
      case APPROVE_QC_REQUEST_SUCCESS:
        draft.record = [record].concat(state.record)
        draft.loading = false
        draft.error = false
        draft.success = success
        break
      case UPDATE_QUOTATION_LIST_SUCCESS:
      case UPDATE_EXPIRY_DATE_SUCCESS:
      case UPDATE_DISCOUNT_PREVIEW_SUCCESS:
        draft.record = [record].concat(state.record)
        draft.loading = false
        draft.error = false
        draft.success = success
        break
      case UPDATE_QUOTATION_RECORD_SUCCESS:
      case UPDATE_INSTRUCTIONS_SUCCESS:
      case UPDATE_VALUE_INSERT_SUCCESS:
      case UPDATE_DELIVERABLE_SUCCESS:
      case UPDATE_PHOTOGRAPHY_SUCCESS:
      case UPDATE_QC_REAPPROVE_SUCCESS:
      case UPDATE_QUOTATION_PREVIEW_SUCCESS:
        draft.record = state.record.find((r) => record._id === r._id)
          ? state.record.map((r) =>
              record._id === r._id ? Object.assign({}, r, record) : r
            )
          : state.record.concat([{ ...record }])
        draft.loading = false
        draft.error = false
        draft.success = success
        break
      case DELETE_QUOTATION_RECORD_SUCCESS:
      case DELETE_INSTRUCTIONS_SUCCESS:
      case DELETE_VALUE_INSERT_SUCCESS:
      case DELETE_DELIVERABLE_SUCCESS:
      case DELETE_PHOTOGRAPHY_SUCCESS:
        draft.record = state.record.filter(
          (r) => r._id.toString() !== id.toString()
        )
        draft.loading = false
        draft.error = false
        draft.success = success
        break
      case LOAD_PROCESS_STATUS_ERROR:
      case LOAD_DELIVERABLE_EMPLOYEE_ERROR:
      case CREATE_QUOTATION_RECORD_ERROR:
      case CREATE_INSTRUCTIONS_ERROR:
      case CREATE_VALUE_INSERT_ERROR:
      case UPDATE_QUOTATION_RECORD_ERROR:
      case DELETE_QUOTATION_RECORD_ERROR:
      case CREATE_DELIVERABLE_ERROR:
      case UPDATE_DELIVERABLE_ERROR:
      case DELETE_DELIVERABLE_ERROR:
      case UPDATE_INSTRUCTIONS_ERROR:
      case UPDATE_VALUE_INSERT_ERROR:
      case UPDATE_EXPIRY_DATE_ERROR:
      case DELETE_INSTRUCTIONS_ERROR:
      case DELETE_VALUE_INSERT_ERROR:
      case CREATE_PHOTOGRAPHY_ERROR:
      case UPDATE_PHOTOGRAPHY_ERROR:
      case UPDATE_QC_REAPPROVE_ERROR:
      case UPDATE_QUOTATION_LIST_ERROR:
      case DELETE_PHOTOGRAPHY_ERROR:
      case LOAD_PHOTOGRAPHY_ERROR:
      case LOAD_DELIVERABLE_DETAILS_ERROR:
      case LOAD_INSTRUCTIONS_ERROR:
      case LOAD_VALUE_INSERT_ERROR:
      case LOAD_SERVICE_ACCOUNT_ERROR:
      case LOAD_SERVICE_DETAILS_ERROR:
      case LOAD_EC_DELIVERABLE_DETAILS_ERROR:
      case LOAD_SALES_APPROVAL_ERROR:
      case UPDATE_DISCOUNT_PREVIEW_ERROR:
      case LOAD_EMPLOYEE_ERROR:
      case LOAD_QC_HISTORY_ERROR:
      case APPROVE_QC_REQUEST_ERROR:
      case UPDATE_QUOTATION_PREVIEW_ERROR:
      case LOAD_QUOTATION_PREVIEW_ERROR:
      case LOAD_RECORD_QUOTATION_DETAILS_ERROR:
        draft.loading = false
        draft.error = error
        draft.success = false
        break
      case LOAD_RECORDS_META_DATA_ERROR:
      case LOAD_DELIVERABLES_RECORDS_META_DATA_ERROR:
      case LOAD_INSTRUCTIONS_RECORDS_META_DATA_ERROR:
        draft.loading = false
        draft.error = error
        draft.success = false
        break
      case LOAD_QUOTATION_HISTORY_DETAILS_ERROR:
      case LOAD_QUOTATION_LIST_ERROR:
        draft.loading = false
        draft.error = error
        draft.success = success
        break
      case LOAD_QC_LAYOUT_MASTER_SUCCESS:
        draft.qc_layout_master = qc_layout_master
        draft.loading = false
        draft.error = error
        draft.success = success
        break
      case LOAD_QC_LAYOUT_MASTER_ERROR:
        draft.loading = false
        draft.error = error
        draft.success = success
        break
      case LOAD_QC_LAYOUT_SEGMENT_SUCCESS:
        draft.qc_layout_segment = qc_layout_segment
        draft.loading = false
        draft.error = error
        draft.success = success
        break
      case LOAD_QC_LAYOUT_SEGMENT_ERROR:
      case ADD_SEGMENT_PREVIEW_ERROR:
        draft.loading = false
        draft.error = error
        draft.success = success
        break
    }
  })
}
